import initMK from '../_core/init.js';
import checkObjectType from '../_helpers/checkobjecttype.js';
import forOwn from '../_helpers/forown.js';
import forEach from '../_helpers/foreach.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import assign from '../_helpers/assign.js';
import bindKey from './_bindkey.js';
export default function bindNode(object, key, node, binder, eventOptions) {
  // read and clear bindOptionalNode's flag first, so a call that throws doesn't leave it for the next one
  var temporaryOptionalFlag = bindNode.temporaryOptionalFlag;
  delete bindNode.temporaryOptionalFlag;
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    eventOptions = binder;
    binder = node;
    node = key;
    key = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'bindNode');
  }
  eventOptions = eventOptions || {};
  binder = binder || {};
  initMK(object);
  // throw an error when key is falsy
  if (!key) {
    throw matreshkaError('binding:falsy_key');
  }
  if (Array.isArray(key)) {
    if (typeof key[0] === 'string') {
      /*
       * accept array of keys
       * this.bindNode(['a', 'b', 'c'], node)
       */
      if (temporaryOptionalFlag) {
        eventOptions = assign({}, eventOptions, {
          optional: true
        });
      }
      forEach(key, function (itemKey) {
        return bindNode(object, itemKey, node, binder, eventOptions);
      });
    } else {
      /*
       * accept array of objects
       * this.bindNode([{key, node, binder, event}], { silent: true });
       */
      forEach(key, function (_ref) {
        var itemKey = _ref.key,
          itemNode = _ref.node,
          itemBinder = _ref.binder,
          itemEventOptions = _ref.event;
        var commonEventOptions = node;
        var mergedEventOptions = {};
        if (temporaryOptionalFlag) {
          mergedEventOptions.optional = true;
        }
        if (commonEventOptions) {
          // extend event object by "global" event
          assign(mergedEventOptions, commonEventOptions);
        }
        if (itemEventOptions) {
          // extend event object by "local" event ("event" key of an object)
          assign(mergedEventOptions, itemEventOptions);
        }
        bindNode(object, itemKey, itemNode, itemBinder, mergedEventOptions);
      });
    }
    return object;
  }
  if (typeof key === 'object') {
    forOwn(key, function (keyObjValue, keyObjKey) {
      // binder means eventOptions
      if (temporaryOptionalFlag) {
        eventOptions = assign({}, binder, {
          optional: true
        });
      } else {
        eventOptions = binder;
      }
      if (keyObjValue && keyObjValue.constructor === Object && 'node' in keyObjValue) {
        // this.bindNode({ key: { node: $(), binder } ) }, { on: 'evt' }, { silent: true });
        bindNode(object, keyObjKey, keyObjValue.node, keyObjValue.binder || node, eventOptions);
      } else if (keyObjValue && keyObjValue.constructor === Array && keyObjValue.length && keyObjValue[0].constructor === Object && 'node' in keyObjValue[0]) {
        // this.bindNode({ key: [{
        //   node: $(),
        //   binder
        // }] ) }, { on: 'evt' }, { silent: true });
        forEach(keyObjValue, function (keyObjValueItem) {
          bindNode(object, keyObjKey, keyObjValueItem.node, keyObjValueItem.binder || node, eventOptions);
        });
      } else {
        // this.bindNode({ key: $() }, { on: 'evt' }, { silent: true });
        bindNode(object, keyObjKey, keyObjValue, node, eventOptions);
      }
    });
    return object;
  }
  return bindKey(object, key, node, binder, eventOptions, temporaryOptionalFlag);
}